import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifyService } from '../../core/services/notify.service';
import { AuthService } from '../../core/services/auth.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {

  form: FormGroup;
  loading = false;
  userID: any;
  error = '';
  showPassword = false;
  showPassword0 = false;
  showPassword1 = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private notifyService: NotifyService,
    private authService: AuthService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ChangePasswordComponent>  
  ) {
    this.form = this.fb.group({
      oldPassword: ['', [Validators.required, Validators.minLength(8)]],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.userID = localStorage.getItem('user');
    this.userID = JSON.parse(this.userID).userId;
    console.log('userID:', this.userID);
    if (!this.userID) {
      this.notifyService.notifyErrorMessage('Missing user ID.');
    }
  }

  validatePassword(password: string): boolean {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  }

  changePassword() {
    if (this.form.invalid) {
      this.notifyService.notifyErrorMessage( 'Please complete the form correctly.');
      return;
    }
    const oldPassword = this.form.value.oldPassword;
    const newPassword = this.form.value.newPassword;
    const confirmPassword = this.form.value.confirmPassword;
    if (!oldPassword || !newPassword || !confirmPassword) {
      this.notifyService.notifyErrorMessage( 'Invalid request data');
      return;
    }
    if (!this.validatePassword(newPassword)) {
      this.notifyService.notifyErrorMessage( 'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one special character and one digit.');
      this.loading = false;
      return;
    }
    if (newPassword !== confirmPassword) {
      this.notifyService.notifyErrorMessage( 'Passwords do not match');
      this.loading = false;
      return;
    }
    this.loading = true;
    this.authService.changePassword(this.userID, oldPassword, newPassword).subscribe(
      (response: any) => {
        if (response?.status) {
          this.notifyService.notifySuccessMessage( 'Password changed successfully');
          this.loading = false;
          this.logout();
          this.removeUser();
        } else {
          this.notifyService.notifyErrorMessage(`Failed to change password: ${response?.message}`);
        }
      },
      (error) => {
        this.notifyService.notifyErrorMessage(`Failed to change password: ${error?.message}`);
      }
    );
  }

  closeDialog() {
   this.dialogRef.close();
  }


  removeUser() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  }

  logout(): void {
    this.authService.logout();
  }

  togglePassword() {
    this.showPassword = !this.showPassword; 
  }
  togglePassword0() {
    this.showPassword0 = !this.showPassword0;
  }
  togglePassword1() {
    this.showPassword1 = !this.showPassword1;
  }
  

}
